import createReducer from 'utils/redux/createReducer'

const initialState = {
  type: 'Bill',
  status: 'All',
  month: 'All',
  property: 'All'
}

export default createReducer(initialState, {
	TRANSACTION_FILTERS_UPDATED: (currentState, action) => (
		{
			type: (action.data.type)? action.data.type : currentState.type
		  , status: (action.data.status)? action.data.status : currentState.status
		  , month: (action.data.month)? action.data.month : currentState.month
		  , property: (action.data.property)? action.data.property : currentState.property
		}
	),
	CLEAR_TRANSACTION_FILTERS: () => initialState
})



// WEBPACK FOOTER //
// ./src/reducers/transactionsFilters.js